import React, { useEffect } from "react";
import useApiHouse from "../api/useApiHouse";
import { useSelector, useDispatch } from "react-redux";
import { statusDetailResponsePayload } from "../api/apiPayloads";
import { setLoader } from "../slices/loaderSlice";
import useGetFormData from "./useGetFormData";

const useStatusDetailResponse = () => {
    const [getStatusDetailResponse, {data, isLoading, error}] = useApiHouse();
    const dispatch = useDispatch();
    const statusDetailResponse = (ediResponseId) => {
        getStatusDetailResponse(statusDetailResponsePayload(ediResponseId));
        dispatch(setLoader({path: "statusDetailLoader.ediLoader", value: true}))
    }
    useEffect(() => {
        if(!isLoading && data){
            dispatch(setLoader({path: "statusDetailLoader.ediLoader", value: false}))
        }
    }, [isLoading, data, error])
    return { statusDetailResponse, data };
}
 
export default useStatusDetailResponse;